import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as CardRelationTypes from 'const/CardRelationTypes'
import { PermissionLevels } from 'utils/permission'
import {
  Button,
  ButtonGroup
} from 'react-bootstrap'
import CardPicker from 'routes/Board/CardPicker'
import KanBoIcon from 'components/KanBoIcon'
import {
  Menu,
  MenuItem
} from 'components/Menu'
import styled from 'styled-components'

const StyledDiv = styled.div`
  background-color: #eceff1;
  padding: 10px;
  border-radius: 5px;
`

export class AddCardRelation extends React.Component {
  static propTypes = {
    boardId: PropTypes.number.isRequired,
    statusId: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    subCardIds: PropTypes.array.isRequired,

    requestChangeCardParent: PropTypes.func.isRequired,
    requestAddCardSequence: PropTypes.func.isRequired,
    requestAddNewCardParent: PropTypes.func.isRequired,
    requestAddNewChildCard: PropTypes.func.isRequired,
    requestAddNewNextCard: PropTypes.func.isRequired,
    requestAddNewPrevCard: PropTypes.func.isRequired,
  }

  state = {
    cardRelationType: null,
    statusId: null,
    cardId: null,
    cardName: null,
    template: null,
  }

  handleChildClick = () => {
    this.setState({
      cardRelationType: CardRelationTypes.CHILD,
      statusId: this.props.statusId,
      cardId: null,
      cardName: null
    })
  }

  handleParentClick = () => {
    this.setState({
      cardRelationType: CardRelationTypes.PARENT,
      statusId: this.props.statusId,
      cardId: null,
      cardName: null
    })
  }

  handleSuccessorClick = () => {
    this.setState({
      cardRelationType: CardRelationTypes.SUCCESSOR,
      statusId: this.props.statusId,
      cardId: null,
      cardName: null
    })
  }

  handlePredecessorClick = () => {
    this.setState({
      cardRelationType: CardRelationTypes.PREDECESSOR,
      statusId: this.props.statusId,
      cardId: null,
      cardName: null
    })
  }

  cardFilter = ({ id }) => (id !== this.props.id && !this.props.subCardIds.includes(id))

  handleStatusChange = (statusId) => {
    this.setState({
      statusId
    })
  }

  handleCardChange = (cardId, cardName) => {
    this.setState({
      cardId,
      cardName
    })
  }

  handleTemplateChange = (template) => {
    this.setState({
      template,
    })
  }

  handleAddClick = () => {
    const {
      onClose,

      id,

      requestChangeCardParent,
      requestAddCardSequence,
      requestAddNewCardParent,
      requestAddNewChildCard,
      requestAddNewNextCard,
      requestAddNewPrevCard,
    } = this.props
    const {
      cardRelationType,
      cardId,
      statusId,
      cardName,
      template,
    } = this.state

    switch (cardRelationType) {
      case CardRelationTypes.CHILD:
        cardId && requestChangeCardParent({
          cardId,
          parentId: id,
        })
        cardName && requestAddNewChildCard({
          statusId,
          name: cardName,
          parentId: id,
          template: template !== 'empty' ? { type: 'card', id: +template } : 'empty',
        })
        break
      case CardRelationTypes.PARENT:
        cardId && requestChangeCardParent({
          cardId: id,
          parentId: cardId
        })
        cardName && requestAddNewCardParent({
          statusId,
          name: cardName,
          childId: id,
          template: template !== 'empty' ? { type: 'card', id: +template } : 'empty',
        })
        break
      case CardRelationTypes.SUCCESSOR:
        cardId && requestAddCardSequence({
          predecessorId: id,
          successorId: cardId
        })
        cardName && requestAddNewNextCard({
          statusId,
          name: cardName,
          predecessorId: id,
          template: template !== 'empty' ? { type: 'card', id: +template } : 'empty',
        })
        break
      case CardRelationTypes.PREDECESSOR:
        cardId && requestAddCardSequence({
          predecessorId: cardId,
          successorId: id
        })
        cardName && requestAddNewPrevCard({
          statusId,
          name: cardName,
          successorId: id,
          template: template !== 'empty' ? { type: 'card', id: +template } : 'empty',
        })
        break
      default:
        break
    }

    onClose()
  }

  render () {
    const {
      onClose,

      boardId,
      statusId
    } = this.props
    const {
      cardRelationType,
      statusId: selectedStatusId,
      cardId,
      cardName
    } = this.state

    if (!cardRelationType) {
      return (
        <Menu style={{ width: '100%' }}>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-relation-parent' />}
            onClick={this.handleParentClick}
          >
            <FormattedMessage id='CARD_RELATION_PARENT' />
          </MenuItem>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-relation-predecessor' />}
            onClick={this.handlePredecessorClick}
          >
            <FormattedMessage id='CARD_RELATION_PREDECESSOR' />
          </MenuItem>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-relation-successor' />}
            onClick={this.handleSuccessorClick}
          >
            <FormattedMessage id='CARD_RELATION_SUCCESSOR' />
          </MenuItem>
          <MenuItem
            icon={<KanBoIcon name='kanbo-16-relation-child' />}
            onClick={this.handleChildClick}
          >
            <FormattedMessage id='CARD_RELATION_CHILD' />
          </MenuItem>
        </Menu>
      )
    } else {
      return (
        <StyledDiv>
          <CardPicker
            board
            status
            card
            currentBoardId={boardId}
            currentStatusId={statusId}
            requiredPermissionLevel={PermissionLevels.MEMBER}
            isTemplate={false}
            cardFilter={this.cardFilter}
            onStatusChange={this.handleStatusChange}
            onCardChange={this.handleCardChange}
            onTemplateChange={this.handleTemplateChange}
          />
          <ButtonGroup>
            <Button
              bsStyle='primary'
              disabled={!selectedStatusId || (!cardId && !cardName)}
              onClick={this.handleAddClick}
            >
              <FormattedMessage id='CARD_RELATION_ADD' />
            </Button>
            <Button
              onClick={onClose}
            >
              <FormattedMessage id='CANCEL' />
            </Button>
          </ButtonGroup>
        </StyledDiv>
      )
    }
  }
}

export default AddCardRelation
